import React from "react"
import { RealRewardProps } from "@hg/activity-utils"
import { EditAddressModal } from "@/components/EditAddressModal"
import RealRewardInfo from "@/components/Reward/components/RealRewardInfo"

const RealReward = ({
    reward,
    step,
    loading,
    contact,
    onContactChange,
    onStepChange,
    onSubmitContact,
    onClose,
    useTempAddress,
}: RealRewardProps) => {
    return (
        <EditAddressModal
            noModal
            open={true}
            onClose={onClose}
            step={step}
            customTitle={<RealRewardInfo reward={{ src: reward.src ?? "", title: reward.title }} />}
            loading={loading}
            contactInfo={contact}
            onContactChange={onContactChange}
            onStepChange={onStepChange}
            onSubmitContact={onSubmitContact}
            useTempAddress={useTempAddress}
        ></EditAddressModal>
    )
}

export default RealReward
